import { useState, useCallback } from 'react';
import axios from 'axios';

export const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get SSO redirect URL
  const getSSORedirectUrl = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_USER_SERVICE_BASE_URL}/sso/nhl?appCode=${process.env.REACT_APP_USER_SERVICE_APP_CODE}&lang=en`
      );
      return response.data.redirectUrl;
    } catch (err) {
      setError(err.message || 'Failed to get SSO redirect URL');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getSSORedirectUrl,
  };
};
